exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* react-table */\n.ReactTable .-padRow {\n  display: none;\n}\n\n.internalDealList select {\n  margin-bottom: 0;\n}\n\n/**\nThe react table's pagination is auto-generated by react-table.\nThere is obviously something not working with their own styles and\nour bootstrap.\nUse this to align the page # and rows input elements.\n */\n.ReactTable .-pagination .-pageJump input {\n  margin-bottom: 0;\n}\n", ""]);

// exports
